import { Component, OnInit , Input , Output,EventEmitter } from '@angular/core';

@Component({
  selector: 'filter-Component',
  templateUrl: './filter.component.html'
})
export class FilterComponent {
    @Input('filter') filter: any ; 
   @Input('size') size: number ;
  @Output('filterBut') ControlName = new EventEmitter<any>(); 
   @Output('Pagesize') ControlpageSize = new EventEmitter<any>(); 
    PSize:Array<any>=[{"size":10},{"size":20},{"size":50},{"size":100}];
    constructor() { } 
    searchBut(event){
      this.ControlName.emit(this.filter);
    }
    getPazeSize(event){
      this.ControlpageSize.emit(this.size);
    }
 }


// WEBPACK FOOTER //
// ./src/app/common/filter/filter.component.ts